// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__38GS2","author":"Table_author__3mnon","authorImage":"Table_authorImage__DusdK","unreadRow":"Table_unreadRow__1n_2-"};